import { c as _c } from "react/compiler-runtime";
import { FormProvider, useForm } from 'react-hook-form';
import Form from '../../../../../form';
import type { FilterMultiSelect, FilterSelectedOption, FilterSingleSelect } from '../../../../filters.types';
type FormData = {
  filter: FilterSelectedOption | FilterSelectedOption[];
};
export enum SelectFormKind {
  multiSelect = 'multi',
  singleSelect = 'single',
}
export type SelectFormProps = {
  kind: SelectFormKind;
  onSubmit: (nextSelectedOptions: string | string[]) => void;
  options: FilterMultiSelect['options'] | FilterSingleSelect['options'];
  selectedOptions: FilterMultiSelect['selectedOptions'] | FilterSingleSelect['selectedOptions'];
};
const SelectForm = t0 => {
  const $ = _c(20);
  const {
    kind,
    onSubmit,
    options,
    selectedOptions
  } = t0;
  let t1;
  if ($[0] !== selectedOptions) {
    t1 = {
      defaultValues: {
        filter: selectedOptions
      }
    };
    $[0] = selectedOptions;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const methods = useForm(t1);
  const {
    handleSubmit
  } = methods;
  let t2;
  if ($[2] !== onSubmit) {
    t2 = formData => {
      onSubmit(formData.filter);
    };
    $[2] = onSubmit;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const handleAfterSubmit = t2;
  let t3;
  if ($[4] !== handleAfterSubmit || $[5] !== handleSubmit) {
    t3 = handleSubmit(handleAfterSubmit);
    $[4] = handleAfterSubmit;
    $[5] = handleSubmit;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== kind || $[8] !== options) {
    t4 = kind === SelectFormKind.multiSelect && <Form.CheckboxGroup name="filter" options={options} className="flex flex-col gap-2" />;
    $[7] = kind;
    $[8] = options;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== kind || $[11] !== options) {
    t5 = kind === SelectFormKind.singleSelect && <Form.RadioGroup name="filter" options={options} className="flex flex-col gap-2" />;
    $[10] = kind;
    $[11] = options;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== t3 || $[14] !== t4 || $[15] !== t5) {
    t6 = <form className="grid gap-2" id="filter-form" onSubmit={t3}>{t4}{t5}</form>;
    $[13] = t3;
    $[14] = t4;
    $[15] = t5;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  let t7;
  if ($[17] !== methods || $[18] !== t6) {
    t7 = <FormProvider {...methods}>{t6}</FormProvider>;
    $[17] = methods;
    $[18] = t6;
    $[19] = t7;
  } else {
    t7 = $[19];
  }
  return t7;
};
export default SelectForm;